import { defineComponent as r, computed as l, openBlock as a, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as h } from "vue";
const f = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "12a1316d-2abc-47b1-b264-da9c2a70bb0b" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#12a1316d-2abc-47b1-b264-da9c2a70bb0b)" }, p = { key: 0 }, v = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 0h512v167l-52.6 83.8L512 345v167H0l72-264.3z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M114.9 166.9H512v178H114.9z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0v512l256-256z"
}, null, -1), b = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "m325 211.5 11.1 34H372l-29 21 11.1 34-29-21-28.9 21 11-34-28.8-21H314zm111.4 0 11 34h35.8l-29 21 11.1 34-29-21-28.9 21 11.1-34-29-21h35.8z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ r({
  __name: "st",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), n = l(() => 256 + t.strokeWidth / 2);
    return (z, y) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (a(), i("title", p, d(t.flagName), 1)) : _("", !0),
        v,
        k,
        g,
        b
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=st-1a6b34e8.js.map
